import { useMutation } from "@tanstack/react-query";
import fetchJSON from "../lib/reactQueryClient";
import { REACT_APP_COMS_BASE_URL } from "constants/constants";



export const resetOtp = async (payload) => {
  const endpoint = `${REACT_APP_COMS_BASE_URL}/api/unblock-phone-number`;

  const options = {
    method: "POST",
    body: payload,
  };

  return await fetchJSON(endpoint, options);
};

export const useResetOtp = () => {
  return useMutation({
    mutationFn: resetOtp,
  });
};
